import React, { createContext, useContext, useEffect, useMemo, useRef, useState } from 'react'

import { getGroupedFields, isGroup } from '../helpers/groups'
import { useManageField } from '../hooks/useManageFields'

const CustomFieldsContext = createContext(null)

export const CustomFieldsProvider = ({ children }) => {
  const [groupedFields, setGroupedFields] = useState([])

  const { fields, currentField, persistFieldChanges, selectedFieldId } = useManageField()

  const autoSaveTimer = useRef(null)

  useEffect(
    function autoSave() {
      if (currentField?.unsaved) {
        autoSaveTimer.current = setTimeout(() => {
          persistFieldChanges({ fieldId: selectedFieldId })
        }, 2000)

        return () => clearTimeout(autoSaveTimer.current)
      }
    },
    [currentField]
  )

  const groupIds = useMemo(() => fields && fields.ids.filter((id) => isGroup(id)), [fields?.ids])

  const currentGroupId = useMemo(
    () => groupIds && groupIds.find((groupId) => fields.entities[groupId]?.fieldGroup === currentField?.fieldGroup),
    [currentField, groupIds]
  )

  useEffect(() => {
    setGroupedFields(getGroupedFields(fields))
  }, [fields?.entities, currentGroupId])

  return (
    <CustomFieldsContext.Provider
      value={{
        groupIds,
        groupedFields,
        setGroupedFields,
        currentGroupId
      }}
    >
      {children}
    </CustomFieldsContext.Provider>
  )
}

export const useCustomFieldsContext = () => {
  const context = useContext(CustomFieldsContext)

  if (!context) {
    throw new Error('useCustomFields must be used with an CustomFieldsProvider')
  }

  return context
}
